module.exports = __webpack_public_path__ + "static/mintorganicset1-b5d5c9c99f61af59dd8fdcd399e6e391.jpeg";